import type { MessageId } from './types';
import { createIntl } from '@formatjs/intl';
import appRu from './ru/app.json';
import fieldsRu from './ru/fields.json';

const ru: Record<MessageId, string> = { ...appRu, ...fieldsRu };

export const intl = createIntl({
  locale: 'ru',
  defaultLocale: 'ru',
  messages: ru,
  onError: () => {},
});

export function t(id: MessageId, values?: Record<string, unknown>): string {
  return intl.formatMessage({ id }, values);
}
